export default __webpack_public_path__ + "static/img_good_team-3f28add7015e89ad7a2a7f9384ab1ae9.png";